
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sports",
      function () {
        return require("private-next-pages/sports/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sports"])
      });
    }
  